/* eslint-disable import/prefer-default-export */
import globalApi from '@/request/globalApi/globalApi'

const END_POINT = 'contact'

export const postContactRequest = (contact, message) => globalApi.post(END_POINT, contact, { message })
